import { FormContentIsland, Grid, HookForm, FormTextField, Button } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { useCardQuery, useCardRenameMutation } from '../../../api/cards';
import { useCallback, useEffect } from 'react';
import { Route } from '../../../routes/account.cards_.$cardId_.name';
import { MainLayout } from '../../Layout/MainLayout';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { useForm } from 'react-hook-form';
import { ApiCardRenameRequest } from '../../../openapi';
import { useFormError } from '../../../hooks/useFormError';

type CardNameFormValues = ApiCardRenameRequest;

export function CardNamePage() {
  const { t } = useTranslation();
  const { cardId } = Route.useParams();
  const cardQuery = useCardQuery({ cardId });
  const mutation = useCardRenameMutation(cardId);
  const navigate = Route.useNavigate();

  const form = useForm<CardNameFormValues>({
    defaultValues: {
      name: cardQuery.data?.name ?? '',
    },
  });

  useFormError(form, 'name', mutation.error);

  useEffect(() => {
    if (mutation.isSuccess) {
      navigate({ to: `/account/cards/${cardId}`, params: { cardId } });
    }
  }, [mutation.isSuccess, navigate, cardId]);

  useEffect(() => {
    if (cardQuery.data) {
      form.reset({ name: cardQuery.data.name ?? '' });
    }
  }, [cardQuery.data, form]);

  const handleSubmit = useCallback(
    (values: CardNameFormValues) => {
      mutation.mutate(values);
    },
    [mutation],
  );

  return (
    <HookForm form={form} onSubmit={handleSubmit}>
      <MainLayout
        title={
          <MainBreadcrumbs
            title={t('Card name')}
            parent={{
              to: '/account/cards/$cardId',
              params: { cardId },
              title: cardQuery.data?.name,
              loading: cardQuery.isPending,
            }}
          />
        }
        compact
      >
        <Grid size={12}>
          <FormContentIsland title={t('Update name')}>
            <FormTextField
              name="name"
              label={t('Name')}
              required
              minLength={1}
              autoComplete="off"
              fullWidth
              autoFocus
            />
          </FormContentIsland>
        </Grid>
        <Grid size={12}>
          <Button
            type="submit"
            size="large"
            color="primary"
            loading={mutation.isPending}
            disabled={!form.formState.isDirty}
            fullWidth
          >
            {t('Update')}
          </Button>
        </Grid>
      </MainLayout>
    </HookForm>
  );
}
